export default "__VITE_ASSET__C8nq2pld__"